import { render, staticRenderFns } from "./CompareRevenueBookingReport.vue?vue&type=template&id=b831152c"
import script from "./CompareRevenueBookingReport.vue?vue&type=script&lang=js"
export * from "./CompareRevenueBookingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports